import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { httpClientCoreQuery } from '@/api/http-client';
import { ICoursePlayerPage } from '@/courses/models';

function generatePlayerPageControllerQuery({ courseId, chapterId }): CoreQuery {
    return new CoreQuery().path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        courseId,
        EntitiesList.CHAPTER,
        chapterId,
        EntitiesList.PAGE,
    ]);
}

export function getCoursePlayerPageDetails({ courseId, chapterId, pageId }): Promise<ICoursePlayerPage> {
    const q = generatePlayerPageControllerQuery({ courseId, chapterId }).path(pageId);

    return httpClientCoreQuery.get(q).then(({ data }) => data);
}

export function getPlayerCourse(id: number | string): Promise<any> {
    const q = new CoreQuery().path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        id,
    ]);

    return httpClientCoreQuery.get(q).then(({ data }) => {
        return data;
    });
}

export function getLastAttempt(guid: number | string, questionType: QuestionType): Promise<QuestionAttemptResult> {
    const q = new CoreQuery().path([
        EntitiesList.CONTENT,
        EntitiesList.PERSONA,
        EntitiesList.QUESTION,
        questionType,
        EntitiesList.ATTEMPT,
        guid,
    ]);

    return httpClientCoreQuery.get(q).then(({ data }) => data);
}

export function submitAttempt(
    request: SubmitAttemptRequest,
    questionType: QuestionType
): Promise<QuestionAttemptResult> {
    const q = new CoreQuery().path([
        EntitiesList.CONTENT,
        EntitiesList.PERSONA,
        EntitiesList.QUESTION,
        questionType,
        EntitiesList.SUBMIT,
    ]);

    return httpClientCoreQuery.post(q, request).then(({ data }) => data);
}

export type QuestionType = 'choice' | 'unknown';
export interface SubmitAttemptRequest {
    question_guid: Guid;
    options: Guid[];
}
export interface QuestionAttemptResult {
    question_guid: Guid;
    passed: boolean;
    options: Guid[];
}
export type Guid = string;
